export default __webpack_public_path__ + "4f2512213a33ed66554d8f7cc2dca460.woff";